// One body scroll lock shared by every sheet over the page. Each caller holds the lock while it is
// open; the page scrolls again only when the last one lets go. Without the count, closing two in one
// render (play) restored one's "" then the other's "hidden" and left the page locked (jaysilvr's
// review of ecomm #99, 2026-10-22).
let holders = 0;
let previousOverflow = '';

export function lockBodyScroll(): () => void {
  if (holders === 0) {
    previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
  }
  holders += 1;
  let released = false;
  return () => {
    if (released) return;
    released = true;
    holders -= 1;
    if (holders === 0) document.body.style.overflow = previousOverflow;
  };
}
